import { render, staticRenderFns } from "./ReviewView.vue?vue&type=template&id=870e9e84"
import script from "./ReviewView.vue?vue&type=script&lang=ts"
export * from "./ReviewView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports